import styled from "styled-components";

export const SwitchContainer = styled.div`
  label {
    position: relative;
    display: inline-block;
    width: 46px;
    height: 26px;
  }

  label input {
    opacity: 0;
    width: 0;
    height: 0;
  }

  .slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: ${({ theme }) => theme.switch.bg.primary} !important;
    -webkit-transition: 0.4s;
    transition: 0.4s;
    border-radius: 34px;

    &::before {
      border-radius: 50%;
      position: absolute;
      content: "";
      height: 20px;
      width: 20px;
      left: 3px;
      top: 3px;
      background-color: ${({ theme }) => theme.switch.bg.secondary};
      transition: 0.4s;
      bottom: 0px;
    }

    &.size-medium {
      height: 30px;
      width: 60px;

      &:before {
        height: 38px;
        width: 36px;
      }
    }

    &.size-large {
      height: 32px;
      width: 68px;

      &:before {
        height: 40px;
        width: 42px;
      }
    }
  }

  input:checked + .slider {
    background-color: ${({ theme }) => theme.button.bg.primary} !important;
  }

  input:focus + .slider {
    box-shadow: 0 0 1px #1f2127;
  }

  input:checked + .slider:before {
    -webkit-transform: translateX(20px);
    -ms-transform: translateX(20px);
    transform: translateX(20px);
  }
`;

export const ToggleContainer = styled.div`
  display: flex;
  align-items: center;
  border-radius: 30px;
  border: 1px solid ${({ theme }) => theme.divider.bg.secondary};
  background-color: ${({ theme }) => theme.switch.bg.quinary};

  .option1 {
    border-radius: 30px;
    font-size: 15px;
    font-weight: 500;
    cursor: pointer;
    padding: 5px 20px;
  }

  .option2 {
    cursor: pointer;
    padding: 5px 22px;
    font-size: 15px;
    font-weight: 500;
    border-radius: 30px;

    .sub-text {
      background-color: ${({ theme }) => theme.tag.bg.primary};
      padding: 2px 8px;
      border-radius: 30px;
      margin-left: 3px;

      &.selected {
        background-color: ${({ theme }) => theme.button.font.primary};
        color: ${({ theme }) => theme.button.bg.primary};
      }
    }
  }

  .checked {
    background-color: ${({ theme }) => theme.button.bg.primary};
    color: ${({ theme }) => theme.button.font.primary};
  }

  @media (max-width: 768px) {
    .option1,
    .option2 {
      font-size: 13px;

      .sub-text {
        padding: 0px 8px;
        font-size: 12px;
      }
    }
  }
`;
